import React from "react";
import Structure from "./layout/Structure";
import "./App.css";

function App() {
  return (
    <div className="App">
      <Structure />
    </div>
  );
}

export default App;
